<span class="hand" (click)="open()">
	{{ translate | translate }}
	<span class="badge light-blue"><i class="bi bi-eyedropper"></i>{{ log.product.getAbbrev() }}-{{ log.experiment.number }}</span>
</span>
